var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorPageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25731",
    "data-name": "Group 25731",
    transform: "translate(-484.967 -484.028)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 55,
    cy: 55,
    r: 55,
    transform: "translate(484.967 484.028)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25728",
    "data-name": "Group 25728",
    transform: "translate(510.375 513.246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25727",
    "data-name": "Group 25727",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37310",
    "data-name": "Path 37310",
    d: "M545.629,577.005h-4.945a4.95,4.95,0,0,1-4.945-4.945V547.371a4.95,4.95,0,0,1,4.945-4.945h4.93a4.951,4.951,0,0,1,4.945,4.945v24.7A4.936,4.936,0,0,1,545.629,577.005ZM540.685,544.9a2.479,2.479,0,0,0-2.475,2.475V572.06a2.479,2.479,0,0,0,2.475,2.475h4.945a2.463,2.463,0,0,0,2.46-2.46v-24.7a2.479,2.479,0,0,0-2.475-2.475Z",
    transform: "translate(-535.74 -542.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37311",
    "data-name": "Path 37311",
    d: "M576.729,601.7a3.955,3.955,0,0,1-3.949-3.949v-1.766a12.189,12.189,0,0,0-2.549-7.434l-9.61-14.578-.2-.677V547.285l.682-1.1,3.806-1.9a17.615,17.615,0,0,1,7.837-1.85h24.724a4.94,4.94,0,0,1,0,9.88v-2.47a2.47,2.47,0,0,0,0-4.94H572.743a15.109,15.109,0,0,0-6.731,1.591l-3.124,1.561V572.93l9.348,14.19a14.553,14.553,0,0,1,3.014,8.872v1.766a1.529,1.529,0,0,0,2.368,1.181A10.133,10.133,0,0,0,581.563,592a10.5,10.5,0,0,0-.469-4.426L578.122,577.1a1.914,1.914,0,0,1,.259-1.717,1.965,1.965,0,0,1,1.618-.85h21.789a3.087,3.087,0,1,0,0-6.175v-2.47a3.087,3.087,0,1,0,0-6.175H598.7v-2.47h3.087a5.556,5.556,0,0,1,3.49,9.88,5.556,5.556,0,0,1-3.49,9.88h-21.13l2.8,9.837a12.894,12.894,0,0,1,.565,5.427,12.608,12.608,0,0,1-4.91,8.635A3.966,3.966,0,0,1,576.729,601.7Zm3.737-25.371.022.072A.336.336,0,0,0,580.466,576.333Z",
    transform: "translate(-548.069 -542.426)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2388",
    "data-name": "Rectangle 2388",
    width: 4.322,
    height: 2.47,
    transform: "translate(49.398 23.464)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37312",
    "data-name": "Path 37312",
    d: "M636.923,567.113h-2.47v-2.47h2.47a2.47,2.47,0,1,0,0-4.94h-2.47v-2.47h2.47a4.94,4.94,0,1,1,0,9.88Z",
    transform: "translate(-585.055 -549.823)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_90",
    "data-name": "Ellipse 90",
    cx: 2.47,
    cy: 2.47,
    r: 2.47,
    transform: "translate(4.94 24.699)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorPageIcon);
export default __webpack_public_path__ + "static/media/error-page-icon.f140674c0ead1610ebe487992521c8b2.svg";
export { ForwardRef as ReactComponent };